import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { enterFullScreen, exitFullScreen } from '../utils';
export var H5Video = forwardRef(function (props, ref) {
    var src = props.src, autoplay = props.autoplay, 
    // height,
    // width,
    poster = props.poster, 
    // fullScreen,
    loop = props.loop, muted = props.muted, onTimeUpdate = props.onTimeUpdate, onReady = props.onReady, onSeeking = props.onSeeking, onSeeked = props.onSeeked, onWaiting = props.onWaiting, onError = props.onError, onFullScreenChange = props.onFullScreenChange, children = props.children;
    var videoRef = useRef(null);
    var videoParentRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        play: function () { var _a; return Promise.resolve((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play()); },
        pause: function () { var _a; return Promise.resolve((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause()); },
        stop: function () { var _a; return Promise.resolve((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause()); },
        load: function () { var _a; return Promise.resolve((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.load()); },
        getCurrentTime: function () { var _a; return Promise.resolve(((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0); },
        getDuration: function () { var _a; return Promise.resolve(((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.duration) || 0); },
        seek: function (position) {
            if (!videoRef.current) {
                return Promise.resolve();
            }
            videoRef.current.currentTime = position;
            return Promise.resolve();
        },
        setVolume: function (value) {
            if (!videoRef.current) {
                return Promise.resolve();
            }
            videoRef.current.volume = value;
            return Promise.resolve();
        },
        setMuted: function (muted) {
            if (!videoRef.current) {
                return Promise.resolve();
            }
            videoRef.current.muted = muted;
            return Promise.resolve();
        },
        setFullScreen: function (fullScreen) {
            if (!videoRef.current || !videoParentRef.current) {
                return Promise.resolve();
            }
            if (fullScreen) {
                enterFullScreen(videoParentRef.current);
            }
            else {
                exitFullScreen(videoParentRef.current);
            }
            onFullScreenChange === null || onFullScreenChange === void 0 ? void 0 : onFullScreenChange({ fullScreen: fullScreen });
            return Promise.resolve();
        },
    }); });
    var onNativeTimeUpdate = onTimeUpdate && (function () {
        var _a, _b;
        return onTimeUpdate({
            currentTime: ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0,
            duration: ((_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.duration) || 0,
        });
    });
    var onNativeReady = onReady && (function () { return onReady(); });
    var onNativeWaiting = onWaiting && (function () { return onWaiting(); });
    var onNativeSeeking = onSeeking && (function () { var _a; return onSeeking({ position: ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0 }); });
    var onNativeSeeked = onSeeked && (function () { var _a; return onSeeked({ position: ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0 }); });
    var onNativeError = onError && (function () { return onError({ errorCode: 0, errorInfo: '' }); });
    return (React.createElement("div", { ref: videoParentRef },
        React.createElement("video", { controls: true, width: "100%", height: "100%", style: {
                width: '100%',
                height: '100%',
            }, ref: videoRef, autoPlay: autoplay, muted: muted, loop: loop, onTimeUpdate: onNativeTimeUpdate, onLoadedData: onNativeReady, onWaiting: onNativeWaiting, onSeeking: onNativeSeeking, onSeeked: onNativeSeeked, onError: onNativeError, poster: poster, src: src }),
        children));
});
